import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { TableRow } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ImportField } from "routes/asset-register/plugins/excel-import/import-field"

export function ImportRow({ item: row }) {
    const { fields } = useBoundContext()
    return (
        <TableRow>
            <Repeat list={fields} item={<ImportField row={row} />} />
        </TableRow>
    )
}
